import React, { useEffect, useRef, useState } from "react";
import { useAnimation } from "framer-motion";
import { useWindowSize } from "@src/utils/useWindowSize";
import {
	Frame,
	Container,
	Lead,
	Text,
	ImgBox,
	SubTitle,
	Title,
	Caption,
	ScrollSuggest,
	Dots,
	CopyRight,
	ToCorporate,
	ImgItem,
} from "./styles";
import { usePrevious } from "@src/utils/usePrevious";
import settings from "@src/settings";
import { GatsbyImageProps } from "gatsby-plugin-image";
import getGridHeight from "@src/utils/getGridHeight";
import { Section } from "@src/components/IndexPage/styles";

interface Props {
	images: (
		| React.ReactElement<HTMLImageElement>
		| React.FunctionComponent<GatsbyImageProps>
	)[];
}
const Hero: React.FC<Props> = (props) => {
	const { images } = props;
	const transitionSpeed = 3000;
	const windowSize = useWindowSize();
	const titleRef = useRef<HTMLHeadingElement>(null);
	const [heroHeight, setHeroHeight] = useState(0);
	const [spaceForTitle, setSpaceForTitle] = useState(0);
	const [activeItem, setActiveItem] = useState(0);
	const previousItem = usePrevious(activeItem);
	const [timer, setTimer] = useState<number | null>(null);
	const setActive = (index: number) => {
		if (timer != null) {
			clearInterval(timer);
		}
		setActiveItem(index);
		setTimeout(() => {
			setTimer(
				window.setInterval(() => {
					setActiveItem((lastItem) =>
						lastItem == images.length - 1 ? 0 : lastItem + 1
					);
				}, transitionSpeed)
			);
		}, 500);
	};
	const imgControl = useAnimation();
	const scrollNext = () => {
		const contentNext = document.querySelector(
			`${Frame} + ${Section}`
		) as HTMLElement;
		if (!window || !contentNext || contentNext?.offsetTop === null) return;
		window.scrollTo({ top: contentNext.offsetTop, behavior: "smooth" });
	};
	useEffect(() => {
		const updateTitleSpace = () => {
			if (titleRef.current) {
				setSpaceForTitle(titleRef.current.getBoundingClientRect().height);
			}
		};
		setTimer(
			window.setInterval(() => {
				setActiveItem((lastItem) =>
					lastItem == images.length - 1 ? 0 : lastItem + 1
				);
			}, transitionSpeed)
		);
		updateTitleSpace();
		window.addEventListener("resize", updateTitleSpace);
		return window.removeEventListener("resize", updateTitleSpace);
	}, []);
	useEffect(() => {
		(async () => {
			imgControl.set((index) => {
				if (index == activeItem) {
					return { zIndex: 0, opacity: 1, width: "100%", height: "100%" };
				}
				if (index == previousItem) {
					return { zIndex: 1, opacity: 1 };
				} else return { opacity: 0 };
			});
			imgControl.start((index) => {
				if (index == activeItem) {
					return {
						opacity: 1,
						width: "105%",
						height: "105%",
						transition: {
							type: "spring",
							stiffness: 80,
							damping: 100,
							mass: 2,
						},
					};
				} else
					return {
						opacity: 0,
						transition: {
							type: "spring",
							stiffness: 80,
							damping: 40,
						},
					};
			});
		})();
	}, [activeItem]);
	useEffect(() => {
		const updateHeroHeight = () => {
			if (windowSize.height) {
				setHeroHeight(
					getGridHeight({
						rows: Math.ceil(
							windowSize.height /
								(settings.baseGrid.fontSize + settings.baseGrid.lineGap)
						),
					})
				);
			}
		};

		//スマートフォンでは初期状態からスクロールした際にアドレスバーの表示／非表示によってwindowのresizeが起きてしまうため、
		//アドレスバーの表示／非表示で変化しないdocumentElement.clientWidth/Heightで本当のwindowResizeか判定
		if (
			!windowSize.previous ||
			windowSize.documentWidth != windowSize.previous.documentWidth ||
			windowSize.documentHeight != windowSize.previous.documentHeight
		) {
			updateHeroHeight();
		}
	}, [windowSize]);
	return (
		<Frame heroHeight={heroHeight}>
			<Container>
				<Lead>
					<Text>
						<Title ref={titleRef} lang="en">
							{windowSize.width == null ||
							windowSize.width >= settings.breakpoint.xl
								? `BE A NEXT WIND\nOF TRADITION`
								: windowSize.width >= settings.breakpoint.lg
								? `BE A\nNEXT WIND\nOF TRADITION`
								: `BE A\nNEXT WIND\nOF\nTRADITION`}
						</Title>
						<SubTitle spaceForTitle={spaceForTitle}>
							革新の姿勢を受け継ぎ
							<br />
							次の時代へ
						</SubTitle>
						<Caption>
							移りゆく時代の中で中橋製作所はいつもその時代の「革新」となることを目指し、産業用刃物製品製造に取り組んで参りました。その姿勢を受け継ぎ、共に次の時代へチャレンジしてくれる仲間を求めています。
						</Caption>
					</Text>
				</Lead>
				<ImgBox>
					{images.map((img, index) => (
						<ImgItem animate={imgControl} custom={index} key={`Img${index}`}>
							{img}
						</ImgItem>
					))}
				</ImgBox>
				<CopyRight>©2022 Nakahashi MFG Co.,Ltd</CopyRight>
				<ToCorporate href="http://ns-co.com" target="_blank">
					企業サイトを開く
				</ToCorporate>
				<ScrollSuggest onClick={scrollNext} />
				<Dots
					length={images.length}
					active={activeItem}
					updateFunc={setActive}
				/>
			</Container>
		</Frame>
	);
};
export default Hero;
